module.exports = __webpack_public_path__ + "img/feedback7-3.ffb4e0f2.jpg";